var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { WordTaskInput } from '../../KnowAWord/WordTask/modules/WordTaskInput';
import { runtime } from '../../../classes/runtime/Runtime';
export class MemorizePointsWordTaskInput extends WordTaskInput {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get wordTask() {
        return this.parent;
    }
    get question() {
        return this.wordTask.question;
    }
    get inputValue() {
        return super.inputValue;
    }
    set inputValue(s) {
        if (runtime.solidBrowserRuntime.browserKeyboard.latestInputAspectTime > runtime.runtimeClock.currentTime - 700 &&
            runtime.solidBrowserRuntime.browserKeyboard.latestInputAspect !== this.wordTask.ownAspect.input) {
            return;
        }
        if (this.question.isOrdered) {
            super.inputValue = s;
        }
        else {
            this.question.memorizePointsRemaining.remainingWordTasks.forEach(wordTask => {
                wordTask.wordTaskInput.inputValueHidden = s;
                wordTask.wordTaskInput.inputValueVisible = '';
            });
            const bestMatching = this.question.memorizePointsUnordered.bestMatchingRemainingWordtask;
            bestMatching.wordTaskInput.inputValueVisible = s;
            bestMatching.wordTaskInput.dateOfInputChange = new Date();
            this.question.memorizePointsRemaining.remainingWordTasks.forEach(wordTask => {
                // 25.06.2021 - fixes React Bug
                if (wordTask.ownAspect.input.aspectMount.domElement) {
                    wordTask.ownAspect.input.aspectMount.domElement.value = wordTask.wordTaskInput.inputValueVisible;
                }
            });
        }
        if (this.wordTask.mutability.m1_whenShouldComplete) {
            runtime.solidBrowserRuntime.browserKeyboard.latestInputAspect = this.wordTask.ownAspect.input;
            runtime.solidBrowserRuntime.browserKeyboard.latestInputAspectTime = runtime.runtimeClock.currentTime;
        }
    }
    get inputValueForEvaluation() {
        if (this.wordTask.wordTaskEvaluate.manifestedEvaluationValue) {
            return this.wordTask.wordTaskEvaluate.manifestedEvaluationValue;
        }
        return this.inputValue;
    }
}
__decorate([
    override
], MemorizePointsWordTaskInput.prototype, "inputValueForEvaluation", null);
